export function HavingTroubleLink({
  onOpenChat,
}: {
  onOpenChat: () => void;
}) {
  return (
    <div className="text-center">
      <button
        type="button"
        onClick={onOpenChat}
        className="text-sm text-gray-400 underline underline-offset-2 hover:text-white inline-block"
      >
        Having trouble?
      </button>
    </div>
  );
}
